export default "__VITE_ASSET__Bgdy4s$v__"